import React, { ReactNode } from 'react';

type BtnTextProps = {
  text?: string;
  hiddenText: boolean;
  node?: ReactNode;
};

export function BtnText({ text, hiddenText, node }: BtnTextProps) {
  return <span className={hiddenText ? 'invisible' : 'btn__text'}>{text || node}</span>;
}
